import React, { useState, useEffect } from 'react';

import { useFetchEntity } from '../../Services/fetchApi';
import Select from '../Form/Selector';
import { endpoints } from '../../utils/Constants';
import Client from '../Cards/Client'
import { useFormikContext, getIn } from 'formik';

const entityClients = { name: 'Client', getByStatus: () => endpoints.getAllClients + '/Active' };

const entityAll = { name: 'Client', getByStatus: () => endpoints.getAllPossibleClients + '/Active' };
const AdminClientSelector = ({ value, id, route, all }) => {

    const entity = all?entityAll: entityClients; 
    const getSelector = (clients) => {
        return clients ? clients.map(client => { return { label: client.companyName + ' | ' + client.firstName + ' | ' + client.lastName + ' | ' + client.email, value: client.id } }) : [];
    }

    const { values, setFieldValue } = useFormikContext();
    const [clients, loading, error] = useFetchEntity(entity);
    const [clientsSelect, setClientsSelect] = useState(clients ? getSelector(clients) : []);
    const [client, setClient] = useState();
    const [selectValue, setSelectValue] = useState();
    const formikValue = getIn(values,id);
    useEffect(() => {
        if (clients) {
            const select = getSelector(clients);
            setClientsSelect(select)
            const c = clients?.find(xx => { return xx.id === value });
            setClient(c);
            const v = select.find(xx => { return xx.value === value });
            setSelectValue(v);
        }
    }, [clients, value]);
    useEffect(() => {
        if (formikValue && clientsSelect && clientsSelect.length) {
            const v = clientsSelect.find(x => x.value === formikValue);
            setSelectValue(v);
            const c = clients?.find(xx => { return xx.id === formikValue });
            setClient(c);
        }
    }, [formikValue, clientsSelect,clients])

    const onSelectChange = (newValue) => {
        setFieldValue(id, newValue.value);
        const c = clients.find(xx => { return xx.id === newValue.value });
        setClient(c);
        const v = clientsSelect?.find(xx => { return xx.value === newValue.value });
        setSelectValue(v);
    }



    return <React.Fragment>

        {clientsSelect ? <Select id="clientId" options={clientsSelect} onChange={onSelectChange} value={selectValue} /> : ''}
        {client ? <Client route={route} client={client} /> : null}
        {loading ? <p>loading</p> : ''}
        {error ? <p>error</p> : ''}
    </React.Fragment>

}

export default AdminClientSelector